<template>
  <page-loader v-if="showLoader" :label="loaderLabel" />
  <RouterView v-if="ready" />
</template>

<script>
import { routes } from '@/router';
import PageLoader from '@components/page-loader.vue';
import useGlobalStore from '@stores/global';
import getRoutesWithProperty from '@utils/get-routes-with-property';

const PUBLIC_PAGES = getRoutesWithProperty(routes, 'is_public');

export default {
  name: 'App',
  components: {
    PageLoader,
  },
  data() {
    return {
      ready: false,
      store: useGlobalStore(),
    };
  },
  computed: {
    showLoader() {
      return !this.ready || this.store.isLoggingOut;
    },
    loaderLabel() {
      return this.store.isLoggingOut ? 'Logging out' : 'Loading';
    },
  },
  created() {
    this.$router.beforeResolve((to, from) => this.routerBeforeResolve(to, from));
  },
  beforeMount() {
    this.getUserProfile().then(() => {
      const resolvedRoute = this.navigationGuard(this.$route);
      if (resolvedRoute) {
        this.$router.push(resolvedRoute).then(() => {
          this.ready = true;
        });
      } else {
        this.ready = true;
      }
    });
  },
  methods: {
    routerBeforeResolve(to, from) {
      this.$logger.resetRouteId();
      this.$logger.info(
        `Moving to page ${to.name}`,
        {
          from: from.fullPath,
          to: to.fullPath,
        },
        true,
      );
      if (from.path !== to.path) {
        this.$httpCancel();
      }
      return this.navigationGuard(to);
    },
    getUserProfile() {
      this.$logger.info('Getting user profile info');
      return this.$http
        .get('/api/profile/user')
        .then(response => {
          this.$logger.info('Got user profile info');
          this.store.logIn(response.data);
        })
        .catch(err => {
          this.$logger.warn('Failed to get user profile info', undefined, err);
        });
    },
    navigationGuard(to) {
      if (!this.store.isLoggedIn && PUBLIC_PAGES.indexOf(to.name) === -1) {
        this.$logger.info('Redirecting to login page', undefined, true);
        return { name: 'login', query: { next: encodeURIComponent(to.fullPath) } };
      }
      if (this.store.isLoggedIn && to.name === 'login') {
        this.$logger.info('Redirecting to hub page', undefined, true);
        return { name: 'hub' };
      }
      return undefined;
    },
  },
};
</script>
